var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInstagramDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.175C16.775 14.175 14.175 16.8 14.175 20C14.175 23.2 16.8 25.825 20 25.825C23.2 25.825 25.825 23.2 25.825 20C25.825 16.8 23.2 14.175 20 14.175ZM37.5 20C37.5 17.575 37.5 15.2 37.375 12.775C37.25 9.975 36.6 7.475 34.55 5.45C32.5 3.4 30.025 2.75 27.225 2.625C24.8 2.5 22.425 2.5 20 2.5C17.575 2.5 15.2 2.5 12.775 2.625C9.975 2.75 7.475 3.4 5.45 5.45C3.4 7.5 2.75 9.975 2.625 12.775C2.5 15.2 2.5 17.575 2.5 20C2.5 22.425 2.5 24.8 2.625 27.225C2.75 30.025 3.4 32.525 5.45 34.55C7.5 36.6 9.975 37.25 12.775 37.375C15.2 37.5 17.575 37.5 20 37.5C22.425 37.5 24.8 37.5 27.225 37.375C30.025 37.25 32.525 36.6 34.55 34.55C36.6 32.5 37.25 30.025 37.375 27.225C37.525 24.825 37.5 22.425 37.5 20ZM20 28.975C15.025 28.975 11.025 24.975 11.025 20C11.025 15.025 15.025 11.025 20 11.025C24.975 11.025 28.975 15.025 28.975 20C28.975 24.975 24.975 28.975 20 28.975ZM29.35 12.75C28.2 12.75 27.25 11.825 27.25 10.65C27.25 9.475 28.175 8.55 29.35 8.55C30.525 8.55 31.45 9.475 31.45 10.65C31.4563 10.9238 31.4063 11.1961 31.3031 11.4498C31.1999 11.7035 31.0457 11.9333 30.85 12.125C30.6583 12.3207 30.4285 12.4749 30.1748 12.5781C29.9211 12.6813 29.6488 12.7313 29.375 12.725L29.35 12.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstagramDark);
export default __webpack_public_path__ + "static/media/ic-instagram-dark.700c95347e4343621e2e254bc5c0e7fe.svg";
export { ForwardRef as ReactComponent };